module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-04-9271d7d33806ce9ef029c62710b2eb92.png";